import { defineStore } from "pinia";
import { computed,ref } from "vue";

export const useAuthStore = defineStore("auth", () => {

  const user = ref(null);
  const payload = ref(null);

  const hasPermission = (permission) => {
    return payload.value && payload.value.permissions.includes(permission);
  }

  const isAuthenticated = computed(() => {
    return user.value !== null && hasPermission('is:user');
  })

  const canAuction = computed(() => {
    return user.value !== null && (hasPermission('view:auction') || hasPermission('view:all_auctions'));
  })

  const canBid = computed(() => {
    return user.value !== null && hasPermission('use:auction');
  })

  return { user, payload, isAuthenticated, canAuction, canBid };
});
